import Home from './Home';
import About from './About';
import AboutUs from './AboutUs';
import Constitution from './Constitution';
import DoctorsList from './DoctorsList';
import NaturopathyCenters from './NaturopathyCenters';
import Contact from './Contact';
import MinuteOfMeeting from './MinuteOfMeeting';
import Gallery from './Gallery';
import StateBoards from './StateBoards';
import MedicalColleges from './MedicalColleges';
import WHONaturopathicWorkforce from './WHONaturopathicWorkforce';
import BNYSSyllabus from './BNYSSyllabus';

function App() {
  const path = window.location.pathname.toLowerCase();
  if (path.includes('about-us')) {
    return (
      <div>
        <AboutUs />
      </div>
    );
  }
  if (path.includes('about')) {
    return (
      <div>
        <About />
      </div>
    );
  }
  if (path.includes('constitution')) {
    return (
      <div>
        <Constitution />
      </div>
    );
  }
  if (path.includes('doctors-list')) {
    return (
      <div>
        <DoctorsList />
      </div>
    );
  }
  if (path.includes('naturopathy-centers')) {
    return (
      <div>
        <NaturopathyCenters />
      </div>
    );
  }
  if (path.includes('contact')) {
    return (
      <div>
        <Contact />
      </div>
    );
  }
  if (path.includes('minute-of-meeting')) {
    return (
      <div>
        <MinuteOfMeeting />
      </div>
    );
  }
  if (path.includes('gallery')) {
    return (
      <div>
        <Gallery />
      </div>
    );
  }
  if (path.includes('state-boards')) {
    return (
      <div>
        <StateBoards />
      </div>
    );
  }
  if (path.includes('medical-colleges')) {
    return (
      <div>
        <MedicalColleges />
      </div>
    );
  }
  if (path.includes('who-naturopathic-workforce')) {
    return (
      <div>
        <WHONaturopathicWorkforce />
      </div>
    );
  }
  if (path.includes('bnys-syllabus')) {
    return (
      <div>
        <BNYSSyllabus />
      </div>
    );
  }
  return (
    <div>
      <Home />
    </div>
  );
}

export default App;


